<template>
    <div class="fixed inset-0 bg-transparent" style="z-index: 9999;" v-if="showModal">
        <div class="bg-black bg-opacity-75 absolute inset-0" @click="closeModal"></div>
        <div class="bg-grey-800 absolute inset-20 n-color-text-weakest flex flex-col">
            <div class="px-6 py-4 flex items-center" v-if="showModal">
                <div><i class="fa-regular fa-file w-3 h-3"></i></div>
                <strong class="flex-1 text-center">
                    {{ fileName }}
                </strong>
                <button @click.prevent="closeModal" class="bg-transparent border-0">
                    <i class="fa-regular fa-xmark w-3 h-3"></i>
                </button>
            </div>
            <div v-if="showModal && fileUrl" class="flex-1">
                <iframe :src="fileUrl" class="w-full h-full border-0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PdfPreviewModal",

    data() {
        return {
            showModal: false,
            fileName: null,
            fileUrl: null,
        }
    },

    methods: {
        closeModal() {
            this.showModal = false;
            this.fileName = null;
            this.fileUrl = null;
        },
    },

    mounted() {
        this.$event_bus.$on('show-pdf-preview-modal', ({ name, url }) => {
            this.showModal = true
            this.fileName = name;
            this.fileUrl = url;
        });
    },

    beforeUnmount() {
        this.$event_bus.$off('show-pdf-preview-modal');
    },
}
</script>
